// src/components/common/HeaderBack.tsx
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { ChevronLeft } from "lucide-react-native";
import { useNavigation } from "@react-navigation/native";
import { FlickOColors } from "../styles/color";
import { getResponsiveSize } from "../styles/globalStyles";
import { NavigationProps } from "../../../types/navigation";

type HeaderBackProps = {
  title?: string;
};

const HeaderBack = ({ title }: HeaderBackProps) => {
  const navigation = useNavigation<NavigationProps>();

  return (
    <View style={styles.header}>
      <TouchableOpacity onPress={() => navigation.goBack()}>
        <ChevronLeft size={24} color={FlickOColors.text.primary} />
      </TouchableOpacity>
      {title && title?.length && <Text style={styles.title}>{title}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(16),

    gap: getResponsiveSize(16),
    backgroundColor: FlickOColors.white,
  },
  title: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
  },
});

export default HeaderBack;
